<template>
  <div class="semsign">
    <!-- 头部banner -->
    <BannerForm
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      title="免费试用"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      setHeight="540"
    >
      <template slot="title">
        <div class="semsign-title-content">
          <div class="one-line">{{ titleOneLine }}</div>
          <div class="two-line">{{ titleTwoLine }}</div>
        </div>
      </template>
      <template slot="desc">
        <div class="semsign-desc">浙江省“最多跑一次”电子签指定供应商</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 具有法律效力的电子印章 -->
    <div class="effect-of-law">
      <SectionCard :isPcFlag="true" :title="secondTitle">
        <img src="@/assets/images/landing-semsign/second-screen.png" alt="" />
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 电子印章一站式管理平台 -->
    <Power class="one-stop-shop" :powerList="powerInfo.powerList" :title="thirdTitle" :btnList="powerInfo.btnList"></Power>
    <!-- 安全可靠的电子签章服务 -->
    <div class="safe-reliable">
      <SectionCard :isPcFlag="true" :title="fourthTitle">
        <div class="content">
          <div class="card" v-for="(item, index) in safeReliableData" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 电子签章应用场景 -->
    <SolutionList
      class="application-scenarios"
      :solutionList="solutionInfo.solutionList"
      :btnList="solutionInfo.btnList"
      :title="fifthTitle"
    ></SolutionList>
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 关于e签宝 -->
    <div class="e-qianbao">
      <SectionCard bgColor="#fbfcfd" :isPcFlag="true" title="关于e签宝">
        <div class="content">
          <div class="left">
            <img class="cover-picture" src="@/assets/images/landing-semsign/cover-picture.png" alt="" />
          </div>
          <div class="right">
            <div class="line"></div>
            <div class="text">
              <div class="text-item" v-for="item in eQianBao" :key="item.key">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
        <el-dialog custom-class="video-dialog" :visible.sync="dialogVideoVisible" :destroy-on-close="true"> </el-dialog>
      </SectionCard>
    </div>
    <!-- 左侧计算机小象 -->
    <LeftBar />

    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <!-- 底部备案信息 -->
    <div class="footer">
      <div class="footer_con">
        <p>
          公司名称：
          <span v-if="RoutingJudgment">广州易签宝网络科技有限公司</span>
          <span v-else>杭州天谷信息科技有限公司</span>
        </p>
        <p>
          销售热线：
          <span v-if="RoutingJudgment">0571-88231350</span>
          <span v-else>0571-85785223</span>
        </p>
        <p>备案信息：浙ICP备11026113号</p>
        <p>增值电信业务经营许可证浙B2-20180376</p>
        <p>浙公网安备 33010602006438号</p>
      </div>
    </div>
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'semsign',
  mixins: [qiyuMixin],
  components: {
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Power: () => import('@/views/mixOs/components/pc/Power.vue'),
    SolutionList: () => import('@/views/mixOs/components/pc/SolutionList.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    // DomainContact: () => import('@/views/extension/components/pc/DomainContact.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
  },
  data() {
    return {
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      pcBgImg: require('../../assets/images/landing-semsign/banner-bg.png'),
      bannerBottomData: dataList.bannerBottomData,
      powerInfo: dataList.powerInfo,
      safeReliableData: dataList.safeReliableData,
      solutionInfo: dataList.solutionInfo,
      orgList: dataList.orgList,
      eQianBao: dataList.eQianBao,
      showScrollForm: false,
      showSuccessDialog: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      dialogVideoVisible: false,
      source: 'yinzhangright', // 咨询来源：客服

      titleOneLine: '', // banner上第一行标题
      titleTwoLine: '', // banner上第二行标题
      secondTitle: '', // 二屏的标题
      thirdTitle: '', // 三屏的标题
      fourthTitle: '', // 四屏的标题
      fifthTitle: '', // 五屏的标题
    }
  },
  computed: {
    RoutingJudgment() {
      return window.location.hostname === 'guangzhou.esign.cn'
    },
  },
  created() {
    // 门户1215需求 电子印章落地页/landing/semsign数据良好，在基础上新增一个电子合同/semcontract和一个电子签章/semsignature版本落地页，需改变几个标题即可。
    if (window.location.pathname === '/landing/semsign') {
      this.titleOneLine = '合法可靠的电子印章'
      this.titleTwoLine = '电子合同平台'
      this.secondTitle = '具有法律效力的电子印章'
      this.thirdTitle = '电子印章一站式管理平台'
      this.fourthTitle = '安全可靠的电子签章服务'
      this.fifthTitle = '电子签章应用场景'
    } else if (window.location.pathname === '/landing/semcontract') {
      this.titleOneLine = '合法可靠的电子合同'
      this.titleTwoLine = '电子签名平台'
      this.secondTitle = '具有法律效力的电子合同'
      this.thirdTitle = '电子合同一站式管理平台'
      this.fourthTitle = '安全可靠的电子合同服务'
      this.fifthTitle = '电子合同应用场景'
    } else if (window.location.pathname === '/landing/semsignature') {
      this.titleOneLine = '合法可靠的电子签章'
      this.titleTwoLine = '电子合同平台'
      this.secondTitle = '具有法律效力的电子签章'
      this.thirdTitle = '电子签章一站式管理平台'
      this.fourthTitle = '安全可靠的电子签章服务'
      this.fifthTitle = '电子签章应用场景'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    // 在线咨询
    OnlineConsultationClick() {
      if (this.RoutingJudgment) {
        this.handleCustomerServiceBaiduClick({ templateId: 6641070 })
      } else {
        // this.handleCustomerServiceClick({ entry: 'yinzhangsecordpage' })
        this.handleNewBaiduService()
      }
    },
  },
}
</script>

<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 1200px;
}

.video-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.semsign {
  width: 100%;
  height: auto;

  // 操作按钮样式
  .btns-box {
    margin-top: 30px;
    .basisDisplay(center, center);
    .btns {
      display: flex;
      & > div {
        width: 181px;
        height: 46px;
        border-radius: 4px;
        font-size: 18px;
        margin: 0 12px;
        cursor: pointer;
        .basisDisplay(center, center);
      }
      .mfsy {
        background: #e63740;
        color: #ffffff;
      }
      .zxzx {
        background: #ffffff;
        box-shadow: 0px 1px 5px 0px rgba(206, 217, 235, 0.74);
        color: #e63740;
      }
    }
  }
  /deep/ .logo {
    width: 126px;
    height: 33px;
  }
  .semsign-title-content {
    font-size: 56px;
    font-weight: 600;
    margin: 30px 0 26px;
  }
  .semsign-desc {
    font-size: 20px;
  }
  .banner-bottom {
    width: 100%;
    height: 80px;
    background: #48494c;
    display: flex;
    .content {
      display: flex;
      margin: 0 auto;
      .item {
        width: 240px;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .first-line-text {
          color: #edd0a3;
          font-size: 19px;
        }
        .second-line-text {
          color: #fff;
          font-size: 20px;
        }
      }
      .item:nth-of-type(odd) {
        background: rgba(94, 93, 93, 0.6);
      }
    }
  }
  // 具有法律效力的电子印章
  // .effect-of-law {
  // }
  // 电子印章一站式管理平台
  .one-stop-shop {
    /deep/ .power-wrap {
      .title {
        font-size: 32px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 45px;
      }
    }
  }
  // 安全可靠的电子签章服务
  .safe-reliable {
    .content {
      display: flex;
      .card {
        width: 285px;
        height: 356px;
        margin-left: 20px;
        padding-bottom: 29px;
        box-shadow: 2px 3px 5px 0px rgba(206, 217, 235, 0.5);
        .title {
          font-size: 20px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
          margin: 20px 0 14px 23px;
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          margin: 0 23px;
        }
      }
    }
  }
  // 电子签章应用场景
  .application-scenarios {
    /deep/ .programme-index {
      background: #fafafc;
      .title {
        background: #fafafc;
        font-size: 32px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 45px;
      }
      .tab-boxs {
        background: #fafafc;
      }
    }
  }
  // 客户案例
  .customer-cases {
    padding-bottom: 72px;
    /deep/ .con-wrap {
      .title {
        font-size: 32px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 45px;
      }
    }
  }
  // 关于e签宝
  .e-qianbao {
    padding-bottom: 72px;
    background: #fbfcfd;
    .content {
      .basisDisplay(space-around, flex-start);
      .left {
        width: 570px;
        height: 321px;
        border: 1px solid #ccc;
        position: relative;
        .play-icon {
          width: 60px;
          height: 60px;
          // border-radius: 50%;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          transition: all 0.4s ease-in-out;
          cursor: pointer;
        }
        .play-icon:hover {
          box-shadow: 0 12px 24px rgb(8 30 80 / 10%);
          transform: translateY(-10px);
        }
        .cover-picture {
          width: 100%;
          height: 100%;
        }
        // video {
        //   width: 100%;
        //   height: 100%;
        // }
      }
      .right {
        width: 545px;
        .line {
          width: 231px;
          height: 3px;
          background: linear-gradient(90deg, #e63740 0%, rgba(244, 104, 116, 0) 100%);
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.85);
          .text-item {
            margin-top: 15px;
            line-height: 26px;
          }
        }
      }
    }
    // 视频
    .video-dialog {
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
  // 底部备案信息
  .footer {
    width: 100%;
    min-height: 58px;
    background: #eee;
    .footer_con {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      text-align: center;
      flex-direction: row;
      margin: auto;
      p {
        font-size: 12px;
        margin: 0;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 58px;
        color: #989898;
      }
    }
  }
}
</style>
